// extracted by mini-css-extract-plugin
export default {"base":"Main_base__3IeiU"};